import React, { useState } from 'react';
import { Box, Button, Paper, Typography, Alert } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

const TokenDebug = () => {
  const { currentUser } = useAuth();
  const [tokenInfo, setTokenInfo] = useState(null);
  const [error, setError] = useState('');

  const checkToken = async () => {
    setError('');
    setTokenInfo(null);
    
    try {
      if (!currentUser) {
        setError('No user logged in');
        return;
      }

      // Get current token (cached)
      const cachedToken = await currentUser.getIdToken(false);
      const cachedResult = await currentUser.getIdTokenResult(false);
      
      // Force refresh token
      const freshToken = await currentUser.getIdToken(true);
      const freshResult = await currentUser.getIdTokenResult(true);
      
      setTokenInfo({
        cached: {
          role: cachedResult.claims.role,
          allClaims: cachedResult.claims,
        },
        fresh: {
          role: freshResult.claims.role,
          allClaims: freshResult.claims,
        }
      });
      
    } catch (err) {
      console.error('Token check error:', err);
      setError(err.message);
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom>
        Token Debug Tool
      </Typography>
      
      <Button variant="contained" onClick={checkToken} sx={{ mb: 2 }}>
        Check Token Claims
      </Button>
      
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      
      {tokenInfo && (
        <Paper sx={{ p: 2 }}>
          <Typography variant="h6" gutterBottom>
            Cached Token
          </Typography>
          <Typography variant="body2" component="pre" sx={{ mb: 2 }}>
            {JSON.stringify(tokenInfo.cached, null, 2)}
          </Typography>
          
          <Typography variant="h6" gutterBottom>
            Fresh Token (After Refresh)
          </Typography>
          <Typography variant="body2" component="pre">
            {JSON.stringify(tokenInfo.fresh, null, 2)}
          </Typography>
        </Paper>
      )}
    </Box>
  );
};

export default TokenDebug;
